import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const MemberNotificationsRoutes: Routes = [
  {
    path: "member-notifications",
    loadComponent: () =>
      import("./member-notifications/member-notifications.component").then(
        (m) => m.MemberNotificationsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./member-notifications-list/member-notifications-list.component").then(
            (m) => m.MemberNotificationsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./member-notifications-form/member-notifications-form.component").then(
            (m) => m.MemberNotificationsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./member-notifications-form/member-notifications-form.component").then(
            (m) => m.MemberNotificationsFormComponent,
          ),
      },
    ],
  },
];
